// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"508d6c45","967":"3f4ac719"}[chunkId] + ".chunk.js";
};